import { useEffect, useState } from 'react';

const slides = [
  {
    image: 'https://public.readdy.ai/ai/img_res/84754a53ca7baf06019be39d632da034.jpg',
    label: '大切なお品を',
    sublabel: '正しい価値で。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=colorful%20bright%20japanese%20trading%20card%20game%20shop%20interior%20pokemon%20one%20piece%20cards%20glass%20display%20cases%20neon%20lighting%20organized%20shelves%20enthusiastic%20card%20collector%20store%20atmosphere%20modern%20clean&width=1920&height=1080&seq=botan-hero2&orientation=landscape',
    label: 'カードの聖地、',
    sublabel: '高松に誕生。',
  },
];

export default function HeroSection() {
  const [current, setCurrent] = useState(0);
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setAnimating(true);
      setTimeout(() => {
        setCurrent((prev) => (prev + 1) % slides.length);
        setAnimating(false);
      }, 500);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative w-full h-screen min-h-[600px] overflow-hidden">
      {/* Background Images */}
      {slides.map((slide, idx) => (
        <div
          key={idx}
          className={`absolute inset-0 transition-opacity duration-1000 ${idx === current ? 'opacity-100' : 'opacity-0'}`}
        >
          <img
            src={slide.image}
            alt=""
            className="w-full h-full object-cover object-center"
          />
        </div>
      ))}

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>

      {/* Content */}
      <div
        className={`relative z-10 flex flex-col items-center justify-center h-full text-center px-6 transition-all duration-500 ${
          animating ? 'opacity-0 translate-y-4' : 'opacity-100 translate-y-0'
        }`}
      >
        <p className="text-xs tracking-[0.35em] text-white/60 uppercase mb-6 font-sans">
          株式会社BotaN
        </p>
        <h1 className="text-5xl md:text-7xl font-serif font-semibold text-white leading-tight mb-4">
          {slides[current].label}
          <br />
          {slides[current].sublabel}
        </h1>
        <p className="text-base md:text-lg text-white/70 max-w-xl mx-auto leading-relaxed mb-10 font-sans font-light">
          買取専門店「天神屋」とカードショップ「まんがく」<br className="hidden md:block" />
          ふたつの専門店で、お客様の価値を最大限に。
        </p>

        <div className="flex flex-col sm:flex-row gap-4 items-center">
          <button
            onClick={() => handleScroll('#services')}
            className="bg-white text-primary font-medium px-8 py-3.5 rounded-full text-sm whitespace-nowrap hover:bg-primary-pale transition-colors duration-200 cursor-pointer"
          >
            事業内容を見る
          </button>
          <button
            onClick={() => handleScroll('#contact')}
            className="border border-white/60 text-white font-medium px-8 py-3.5 rounded-full text-sm whitespace-nowrap hover:bg-white/10 transition-colors duration-200 cursor-pointer"
          >
            お問い合わせ
          </button>
        </div>
      </div>

      {/* Slide Indicators */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex gap-2 z-10">
        {slides.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrent(idx)}
            className={`w-8 h-1 rounded-full transition-all duration-300 cursor-pointer ${
              idx === current ? 'bg-white' : 'bg-white/30'
            }`}
          ></button>
        ))}
      </div>

      {/* Scroll Down */}
      <div className="absolute bottom-10 right-10 hidden md:flex flex-col items-center gap-2 z-10">
        <p className="text-xs text-white/40 tracking-widest uppercase" style={{ writingMode: 'vertical-rl' }}>Scroll</p>
        <div className="w-px h-10 bg-white/20 relative overflow-hidden">
          <div className="absolute top-0 w-full h-1/2 bg-white/60 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}
